import { StyledP } from './Paragraph.styles';
import { ParagraphProps } from './Paragraph.types';

const Paragraph = ({ children, ...rest }: ParagraphProps): JSX.Element => {
  return <StyledP {...rest}>{children}</StyledP>;
};

export default Paragraph;
